/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

'use strict';

angular.module('prism-ui.components').service('FfmpegTemplatesService', function (this: JS5Object, _: JS5Object, FFmpegTemplatesResourceFactory: JS5Object) {
    this.originalEditData = {};

    this.getAllFfmpegTemplates = (queryParams: JS5Object, queryHandler: JS5Function) => {
        return FFmpegTemplatesResourceFactory.query(queryParams, queryHandler).$promise;
    };
    this.getFfmpegTemplate = (ffmpegTemplateId: number) => {
        return FFmpegTemplatesResourceFactory.get({id: ffmpegTemplateId}).$promise;
    };
    this.createFfmpegTemplate = (ffmpegTemplate: JS5Object) => {
        return FFmpegTemplatesResourceFactory.save(ffmpegTemplate).$promise;
    };
    this.cloneFfmpegTemplate = (ffmpegTemplate: JS5Object) => {
        return FFmpegTemplatesResourceFactory.clone({id: ffmpegTemplate.id}).$promise;
    };
    this.updateFfmpegTemplate = (ffmpegTemplate: JS5Object) => {
        return FFmpegTemplatesResourceFactory.update(ffmpegTemplate).$promise;
    };
    this.toggleFfmpegTemplateHidden = (ffmpegTemplateId: number) => {
        return FFmpegTemplatesResourceFactory.toggleArchive({id: ffmpegTemplateId}).$promise;
    };
});
